import i18n from '../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class ActivitySearch extends BaseModel {
  action = null;

  rules = {};

  attributeLabels = {
    action: i18n.t('Action'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(ActivitySearch);
